import { TFunction } from "i18next";
import { z } from "zod";

import { emailRule, nameRule, phoneRule } from "src/core/forms/validators/rules";

export const contactInformationSchema = (t: TFunction, showContactInfo = false) =>
  z.object({
    prenom: nameRule(t, { checkIfShown: showContactInfo }),
    nom: nameRule(t, { checkIfShown: showContactInfo }),
    email: emailRule(t, showContactInfo),
    telephone: phoneRule(t, showContactInfo),
  });

export type ContactInformationFieldsValues = z.infer<ReturnType<typeof contactInformationSchema>>;

export const defaultContactInformationValues = (): ContactInformationFieldsValues => {
  return {
    prenom: "",
    nom: "",
    email: "",
    telephone: "",
  };
};
